
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1uyZT", function(module, exports) {
$parcel$export(module.exports, "RecommendPremiumToStandardModalComponent", () => $3d515e10f99142ca$export$e2ad8f867d457fc6);

var $eJOHy = parcelRequire("eJOHy");

var $2xQhw = parcelRequire("2xQhw");

var $3ZKAH = parcelRequire("3ZKAH");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $cxKOj = parcelRequire("cxKOj");

var $eWzpp = parcelRequire("eWzpp");

var $1BZ8a = parcelRequire("1BZ8a");

var $cHtIB = parcelRequire("cHtIB");

var $8Q6yE = parcelRequire("8Q6yE");

var $4cTDP = parcelRequire("4cTDP");

var $5tQVZ = parcelRequire("5tQVZ");

var $7jHKK = parcelRequire("7jHKK");

var $c0zsP = parcelRequire("c0zsP");
const $3d515e10f99142ca$var$RecommendPremiumToStandardModalComponentImpl = ()=>{
    const cloudID = (0, $cHtIB.useCloudId)();
    const RecommendPremiumToStandardModalEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudIds: [
                cloudID
            ],
            isTwcJiraTouchPointFix: (0, $4cTDP.fg)('twc_jira_touchpoint_fix')
        }), [
        cloudID
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $7jHKK.recommendPremiumToStandardModalEntryPoint), RecommendPremiumToStandardModalEntryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.jiraRecommendPremiumToStandard",
        packageName: "jira-recommend-premium-to-standard-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: "unmount",
        runtimeProps: {}
    });
};
const $3d515e10f99142ca$var$ExperimentWrapper = ({ children: children })=>{
    const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_reverse_trial_ea_updates_during_trial');
    const experimentCohort = (0, $eJOHy.useMemo)(()=>config.get('cohort', 'not-enrolled'), [
        config
    ]);
    if (experimentCohort === (0, $3ZKAH.VARIATION) && (0, $4cTDP.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) return null;
    return children;
};
const $3d515e10f99142ca$export$e2ad8f867d457fc6 = ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $2xQhw.toProjectType)(project?.type);
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const productKey = projectType && (0, $2xQhw.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const daysLeft = (0, $5tQVZ.useMemoizedTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0;
    const eligibleDaysLeft = daysLeft === 1 || daysLeft === 3 || daysLeft === 5;
    // dont preload component if not correct edition, software project open, not ccp
    if (!(0, $c0zsP.isProjectTypeAndEditionSupported)(appEditions, project?.type) || billingSourceSystem !== 'CCP' || !eligibleDaysLeft) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d515e10f99142ca$var$ExperimentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d515e10f99142ca$var$RecommendPremiumToStandardModalComponentImpl, null));
};

});
parcelRegister("3ZKAH", function(module, exports) {
$parcel$export(module.exports, "NOT_ENROLLED", () => $38addf99531006d5$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $38addf99531006d5$export$fa04ad826acc90da);

var $bi9FK = parcelRequire("bi9FK");
const $38addf99531006d5$export$3d370c33621572df = 'cohort';
const $38addf99531006d5$export$5b7423264d48ab04 = 'not-enrolled';
const $38addf99531006d5$export$43f367b3e957f219 = 'control';
const $38addf99531006d5$export$9ba2bc3b1bdc1519 = 'experiment';
const $38addf99531006d5$export$fa04ad826acc90da = 'variation';
const $38addf99531006d5$export$6486974e39493fa6 = 'variation-1';
const $38addf99531006d5$export$7d994996134ad562 = 'variation-2';
const $38addf99531006d5$export$795e7d69b248dcd0 = 'variation-3';
const $38addf99531006d5$export$c9c947c57470b787 = 'variation-4';
const $38addf99531006d5$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $38addf99531006d5$export$5b7423264d48ab04,
    $38addf99531006d5$export$43f367b3e957f219,
    $38addf99531006d5$export$9ba2bc3b1bdc1519,
    $38addf99531006d5$export$fa04ad826acc90da,
    $38addf99531006d5$export$6486974e39493fa6,
    $38addf99531006d5$export$7d994996134ad562,
    $38addf99531006d5$export$795e7d69b248dcd0,
    $38addf99531006d5$export$c9c947c57470b787
];
// Use optionalValidExperimentGroups to further restrict the list of cohorts
const $38addf99531006d5$var$getExperimentGroup = (experimentFeatureFlag, validExperimentGroups = $38addf99531006d5$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $bi9FK.getMultivariateFeatureFlag)(experimentFeatureFlag, $38addf99531006d5$export$5b7423264d48ab04, validExperimentGroups);
var $38addf99531006d5$export$2e2bcd8739ae039 = $38addf99531006d5$var$getExperimentGroup;

});

parcelRegister("7jHKK", function(module, exports) {
$parcel$export(module.exports, "recommendPremiumToStandardModalEntryPoint", () => $b3b1f5b8b7fa4314$export$cfb9acf6e9b90816);

var $g65dK = parcelRequire("g65dK");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b3b1f5b8b7fa4314$export$cfb9acf6e9b90816 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(async ()=>(parcelRequire("s3wo9")).then(({ RecommendPremiumToStandardModalRenderer: RecommendPremiumToStandardModalRenderer })=>RecommendPremiumToStandardModalRenderer), {
        moduleId: "bbcbd999",
        moduleName: "RecommendPremiumToStandardModalRenderer",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudIds: cloudIds, isTwcJiraTouchPointFix: isTwcJiraTouchPointFix })=>({
            queries: {
                getRecommendPremiumToStandardUrlQuery: {
                    parameters: (0, $g65dK.default),
                    variables: {
                        cloudIds: cloudIds,
                        isTwcJiraTouchPointFix: isTwcJiraTouchPointFix
                    }
                }
            }
        })
});

});
parcelRegister("g65dK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb80d106a39c90fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0fae14a2241e15be35e665c2220ea863>>
 * @relayHash c77f53b35a81e814d039a78d8e2aedca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1bdd8cfa86ba824ded85a0754d83db9a4352165261a9717dd1e638a9ae45f71d
const $fb80d106a39c90fc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1bdd8cfa86ba824ded85a0754d83db9a4352165261a9717dd1e638a9ae45f71d",
        "metadata": {},
        "name": "RecommendPremiumToStandardModalRendererQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fb80d106a39c90fc$export$2e2bcd8739ae039 = $fb80d106a39c90fc$var$node;

});

parcelRegister("s3wo9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f9j1j").then(()=>parcelRequire('27N5H'));

});


parcelRegister("c0zsP", function(module, exports) {
$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $776e662aa62bffcd$export$c9a5a2a3868318aa);

var $2xQhw = parcelRequire("2xQhw");

var $cblKs = parcelRequire("cblKs");
const $776e662aa62bffcd$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $2xQhw.toProjectType)(project);
    if (!projectType || projectType !== (0, $2xQhw.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $cblKs.PREMIUM_EDITION);
};

});



//# sourceMappingURL=async-recommend-premium-to-standard-modal.dbe0d9bb.js.map
